module.exports = __webpack_public_path__ + "img/hu.8f4c3903.svg";